module.exports = __webpack_public_path__ + "media/stylesheets/images/steven-sign-eb6e03feb8f77c227adba6aa4cf84e0b.png";